var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperience({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/experience"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.382 8.194 7.12 5.31 3.957 4.033 3 5.129l1.568 3.103 2.814-.038Zm0 0 3.193 2.957m1.563 4.089 5.677 5.256a1.87 1.87 0 0 0 2.696-.147c.704-.807.64-2.05-.143-2.776L15.4 12.974m2.55-9.533a4.678 4.678 0 0 0-5.53 1.187c-1.322 1.515-1.562 3.645-.769 5.38a1.928 1.928 0 0 0-.355.318l-6.381 7.307a2.005 2.005 0 0 0 .143 2.775 1.87 1.87 0 0 0 2.695-.147l6.381-7.307c.108-.124.198-.258.27-.398 1.76.628 3.79.158 5.114-1.358 1.428-1.636 1.593-3.987.56-5.785l-3.044 3.486-2.13-1.971 3.045-3.486Z",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience);
export default __webpack_public_path__ + "static/media/experience.300f2491fd10819e1731bb32c458165e.svg";
export { ForwardRef as ReactComponent };